module.exports = __webpack_public_path__ + "onelogin-logo-345d566c2a64a7ddd50a2fe8c7995876.webp";